import {
    PANEL_SET_PARAM,
    PANEL_UNSET_PARAM
} from '~/frontend/src/constants';
import {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import {UnsetParamAction} from '~/frontend/src/actions/panel/common/unsetParam';

export type PanelState = Partial<{
    [ key : string ] : any;
}>;

const relevantActions = [
    PANEL_SET_PARAM,
    PANEL_UNSET_PARAM
];

/**
 *
 * @param state
 * @param action
 */
export default function commonReducer( state : PanelState = {}, action : SetParamAction | UnsetParamAction ) : PanelState {
    let outState = state,
        changed = false,
        paramKey,
        paramValue;

    if ( relevantActions.includes( action.type ) ) {

        // copy current (stay immutable!)
        outState = {
            ...outState
        };

        switch ( action.type ) {

            case PANEL_SET_PARAM:
                ( { paramKey, paramValue } = action );

                if ( JSON.stringify( outState[ paramKey ] ) !== JSON.stringify( paramValue ) ) {
                    changed = true;

                    outState[ paramKey ] = paramValue as never;
                }

                break;

            case PANEL_UNSET_PARAM:
                ( { paramKey } = action );

                if ( outState[ paramKey ] !== undefined ) {
                    changed = true;

                    delete outState[ paramKey ];
                }

                break;
        }

        if ( !changed ) {
            outState = state;
        }
    }

    return outState;
}
